import { Box, Drawer, IconButton, List, ListItem, ListItemText, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles((theme) => ({
    button: {
      color: 'white',
      padding: 0,
      margin: 0,
    },
    list: {
      width: 250,
    },
    root: {
      marginRight: theme.spacing(2)
    }
  }));

export default function MobileDrawer({ linkNavs, handleClick }) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const toggleDrawer = (state) => (event) => {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }

      setOpen(state);
    };
    
    const list = () => (
      <div
        className={classes.list}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
        <List>
          {linkNavs.map((item, index) => (
            <ListItem button key={index}>
              <ListItemText primary={item.title} onClick={() => handleClick(item.to)} />
            </ListItem>
          ))}
        </List>
      </div>
    );
  
    return (
      <Box className={classes.root} display={{ xs: 'block', sm: 'none' }}>
        <IconButton className={classes.button} onClick={toggleDrawer(true)}><MenuIcon /></IconButton>
        <Drawer anchor='left' open={open} onClose={toggleDrawer(false)}>
            {list()}
        </Drawer>
      </Box>
    );
  }